/* global google */
export default class IndoorFloorSwitchControl{
    constructor(controlDiv, map, initialPosition, upClb, downClb){
        // Set CSS styles for the DIV containing the control
        // Setting padding to 5 px will offset the control
        // from the edge of the map
        controlDiv.style.padding = '10px';

        /** Wrapper */
        var controlUI = document.createElement('div');
        controlUI.className = "mapIndoorFloorSwitchWrapper";
        controlDiv.appendChild(controlUI);

        /** UP Arrow */
        var controlText = document.createElement('div');
        controlText.id = "mapIndoorFloorSwitch_UP";
        controlText.className = "mapIndoorFloorSwitchBtn";
        controlText.innerHTML = '▲';
        controlUI.appendChild(controlText);
        google.maps.event.addDomListener(controlText, 'click', upClb);

        /** Edit Box */
        var controlText2 = document.createElement('div');
        controlText2.id = "mapIndoorFloorSwitch_input";
        controlText2.className = "mapIndoorFloorSwitchInput";
        controlText2.innerHTML = initialPosition;
        controlUI.appendChild(controlText2);

        /** DOWN Arrow */
        var controlText3 = document.createElement('div');
        controlText3.id = "mapIndoorFloorSwitch_DOWN";
        controlText3.className = "mapIndoorFloorSwitchBtn";
        controlText3.innerHTML = '▼';
        controlUI.appendChild(controlText3);
        google.maps.event.addDomListener(controlText3, 'click', downClb);
    }


        
}